// row 104 Conflicts (`conflicts`): a disclosure *Conflicts · n* with one row per attendee and the reason (his words: OOF ·
// working hours · room · time zone), and a flag Pill *Conflict* beside the heading when n > 0. The panel stays in the
// DOM (F4a's Disclosure), so aria-controls always resolves; with no conflicts the heading reads *Conflicts · 0*.

import type { ReactNode } from "react";
import { Disclosure, Person, Pill, Row } from "../core";
import { cx } from "../lib/cx";
import { G7_TEMPLATES, SCHEDULING_LABELS } from "./labels";
import type { Hs } from "../lib/hs";

export interface ConflictItem {
  /** The attendee (a person, the candidate, or the room's words). */
  name: string;
  candidate?: boolean | undefined;
  /** The reason, in his words. */
  reason: ReactNode;
}

export interface ConflictsProps {
  items: readonly ConflictItem[];
  open?: boolean | undefined;
  defaultOpen?: boolean | undefined;
  onOpenChange?: ((open: boolean) => void) | undefined;
  can?: boolean | undefined;
  hs?: Hs | undefined;
  className?: string | undefined;
}

export function Conflicts({ items, open, defaultOpen, onOpenChange, can, hs, className }: ConflictsProps) {
  if (can === false) return null;
  const n = items.length;
  return (
    <Disclosure
      className={cx("mc-conflicts", className)}
      title={G7_TEMPLATES.conflictsCount({ n })}
      right={n > 0 ? <Pill tone="flag">{SCHEDULING_LABELS.conflict}</Pill> : undefined}
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      hs={hs}
    >
      <div className="mc-conflicts-rows">
        {items.map((item, index) => (
          <Row key={index} cols={2} lead="45%">
            <Person name={item.name} candidate={item.candidate} size={24} />
            <span className="mc-conflicts-why">{item.reason}</span>
          </Row>
        ))}
      </div>
    </Disclosure>
  );
}
